import { DatePipe } from '@angular/common';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { AddproductComponent } from 'src/app/components/product/addproduct/addproduct.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
@Component({
  selector: 'app-addtransfer',
  templateUrl: './addtransfer.component.html',
  styleUrls: ['./addtransfer.component.css']
})
export class AddtransferComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  transfermainColl: any = [];

  transferBO: any = {}
 

  transferdetailscoll: any = [];

  ismanualclose: boolean;

  qtytotal: number = 0;
  unitpricetotal: number = 0;
  subtotal: number = 0;


  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  transferform = new FormGroup({
    transferid: new FormControl(0),
    transferno: new FormControl('', Validators.required),
    transferdate: new FormControl(null, Validators.required),
    refno: new FormControl(''),
    grandtotal: new FormControl(null),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Transfer";

  gridfocusrow: number = -1;

  @Input() transferid: number = 0
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();

  currencyMask:any="";

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

      this.currencyMask=this.loginService.fngetDecimalPlaces()
      
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.transferform.reset();
      this.fnInitializeForm();

      if (this.transferid > 0) {
        this.fngetTransfer();
      }
      else {
        this.fnSetFirstRowItem()
      }
      this.fnGetRawmaterial();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }





  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.transferid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.israwmaterialaddmode = this.loginService.fnCheckUserRoleAction("Rawmaterial", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.transferform.setValue({
      transferid: 0,
      transferno: 'NEW',
      transferdate: new Date(),
      grandtotal: null,
      descr: null,
      refno: '',
      inactive: false,
    })
  }


  //Get 
  fngetTransfer() {

    var data = {
      'transferid': this.transferid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTransfer(data)
      .subscribe(
        (res) => {
          var result = res.json().result;
         
          this.transfermainColl = result[0];

          var editdata = this.transfermainColl[0];
          this.transferBO = editdata;
          this.fnEditMode(editdata);

          this.transferdetailscoll = result[1];
          //console.log(this.transferdetailscoll)

          if (this.transferdetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcDetails();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.transferdetailscoll) {
      if (row.rawmaterialid > 0) {
        _detailscheck = true;
      }
    }

    if (!_detailscheck) {
      this.errtxt = "transferustment Details cannot be empty"
      this.transferform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      for (let row of this.transferdetailscoll) {

        if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
          this.errtxt = "Quantity is cannot be empty"
          this.transferform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.transferform.get('inactive')) {
      this.transferform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.transferform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'transferid': this.transferid,
          'transferno': this.transferform.get('transferno').value,
          'transferdate': this.fnFormatDatetime(this.transferform.get('transferdate').value),
          'grandtotal': this.transferform.get('grandtotal').value,
          'descr': this.transferform.get('descr').value,
          'refno': this.transferform.get('refno').value,
          'inactive': this.transferform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'transferdetailscoll': this.transferdetailscoll,
        }

        if (this.transferform.get('transferid').value > 0) {

          this.fnSetTransfer(data);
        }
        else {

          this.fnInsertTransfer(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertTransfer(data) {

    this.appService.fnInsertTransfer(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new transferustment has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.transferno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].transferid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTransfer(data) {

    this.appService.fnSetTransfer(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The transferustment has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.transferid, data.transferno);

          this.fnEditFormEdit(this.transferid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.transferdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transferdate));


    this.transferform.setValue({

      transferid: deptBO.transferid,
      transferno: deptBO.transferno,
      transferdate: deptBO.transferdate,
      grandtotal: deptBO.grandtotal,
      descr: deptBO.descr,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.transferid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial(index) {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    for (let row of this.transferdetailscoll) {
      row.subtotal = row.qty * row.unitprice;
      this.subtotal = this.subtotal + Number(row.subtotal)



    }
    this.fnCalcsSummaryTotal()
  }




  fnCalcsSummaryTotal() {
    this.qtytotal = 0;
    this.unitpricetotal = 0;
    this.subtotal = 0;


    for (let row of this.transferdetailscoll) {
      this.qtytotal = Number(this.fnConvertDecimal(this.qtytotal)) + Number(this.fnConvertDecimal(row.qty))
      this.unitpricetotal = Number(this.fnConvertDecimal(this.unitpricetotal)) + row.unitprice
      this.subtotal = Number(this.fnConvertDecimal(this.subtotal)) + row.subtotal

    }
    this.transferform.patchValue({ grandtotal: this.subtotal })
  }




  fnDeleteTransferConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.transferdetailscoll.splice(index, 1)
            if (this.transferdetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnChangeRawmaterial(index) {

    var _prodname = "", _unitprice = 0;

    for (let abo of this.rawmaterialColl) {
      if (this.transferdetailscoll[index].rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;


      }
    }
    this.transferdetailscoll[index].rawmaterialname = _prodname;
    this.transferdetailscoll[index].unitprice = _unitprice;



  }


  fnSetFirstRowItem() {
    if (this.transferdetailscoll.length > 0) {
      if (!this.transferdetailscoll[this.transferdetailscoll.length - 1].rawmaterialid) {
        return
      }
    }

    var data = {
      transferdetailsid: 0,
      transferid: 0,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: 0,
      unitprice: 0,
      subtotal: 0,

    }

    this.transferdetailscoll.push(data)

  }
  fnGetFirstRowItem() {

    var data = {
      transferdetailsid:null,
      transferid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: null,
      unitprice:null,
      subtotal:null,
      uomid: null,
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal:null
    }

    return data;

  }


  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnSetNextFocus(index) {

    if (this.transferdetailscoll.length > 0) {

      if (this.transferdetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.transferdetailscoll[index].rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial(index);

    });
  }
  //Print
  // private fnPrinttransfer() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.transferid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.transferid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  // fnAddtransferdetails() {

  //   const modalRef = this.productFindService.open(AddtransferdetailComponent, { size: <any>'l' });
  //   modalRef.componentInstance.transferdetailsBO=this.fnGetFirstRowItem()
  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //     if (receivedEntry.checkstatus === "DONE") {
  //       this.fnSetFirstRowItem()
  //       this.transferdetailscoll[this.transferdetailscoll.length - 1] = receivedEntry.data;
  //       this.fnCalcDetails()
  //     }
  //   });
  // }

  
  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' transferustment?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.transferid,
      doctype: 'TRANSFER',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
        
            this.fnEditFormEdit(this.transferid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.transferid,
      doctype: 'TRANSFER',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {
          
          if (res.json().status === 200) {
          
            var result=res.json().result;
           
            if(result.length>0){
         
              if(result[0].checkresult==='DONE'){
                this.fnEditFormEdit(this.transferid);
              }
              else{
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }
           
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  
  fnEnableEditBtn() {
    if(this.transferBO.iscancelled===1){
      return false;
    }
    else if (this.transferBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if(this.transferBO.iscancelled===1){
      return false;
    }
    else  if (this.transferBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }


  
  fnEnableUnPostBtn() {
    if (this.transferBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }
    
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
